(function() { window.GUID_368c60d8_159f_4f58_a243_85f11e64bc6e = { getGuid: function() { return "368c60d8-159f-4f58-a243-85f11e64bc6e"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let NotificationType;
        (function (NotificationType) {
            NotificationType[NotificationType["Email"] = 0] = "Email";
            NotificationType[NotificationType["Push"] = 1] = "Push";
        })(NotificationType = Enumeration.NotificationType || (Enumeration.NotificationType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NotificationType.pre.js.map
